
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/

export const ProjectCategory = {
  BINARY_TREE: 'BINARY_TREE',
  LINKED_LIST: 'LINKED_LIST',
  BST: 'BST',
  GRAPH: 'GRAPH',
  GRID: 'GRID',
  ARRAY: 'ARRAY',
  HEAP: 'HEAP',
  STACK: 'STACK',
  TWO_POINTERS: 'TWO_POINTERS',
  BINARY_SEARCH: 'BINARY_SEARCH',
  SLIDING_WINDOW: 'SLIDING_WINDOW',
  BACKTRACKING: 'BACKTRACKING',
  DYNAMIC_PROGRAMMING: 'DYNAMIC_PROGRAMMING',
  TRIE: 'TRIE',
  BIT_MANIPULATION: 'BIT_MANIPULATION',
  MATH: 'MATH'
} as const

export type ProjectCategory = (typeof ProjectCategory)[keyof typeof ProjectCategory]


export const ProjectDifficulty = {
  EASY: 'EASY',
  MEDIUM: 'MEDIUM',
  HARD: 'HARD'
} as const

export type ProjectDifficulty = (typeof ProjectDifficulty)[keyof typeof ProjectDifficulty]


export const CodeLanguage = {
  JavaScript: 'JavaScript',
  Python: 'Python'
} as const

export type CodeLanguage = (typeof CodeLanguage)[keyof typeof CodeLanguage]
